<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="600px"
    >
      <v-card>
        <bar-title-dialog
          title="Abrir Caixa"
          @close="dialog=false"
        ></bar-title-dialog>

        <v-card-text class="pb-0">
          <v-row dense>
            <v-col
              cols="12"
              md="4"
            >
              <v-card
                outlined
                class="pa-3"
              >
                <div class="caption text--secondary">
                  Responsável
                </div>
                <div class="subtitle-1 font-weight-bold mt-1">
                  {{ currentUserName }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="4"
            >
              <v-card
                outlined
                class="pa-3"
              >
                <div class="caption text--secondary">
                  Data
                </div>
                <div class="subtitle-1 font-weight-bold mt-1">
                  {{ currentDate }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="4"
            >
              <v-card
                outlined
                class="pa-3"
              >
                <div class="caption text--secondary">
                  Hora
                </div>
                <div class="subtitle-1 font-weight-bold mt-1">
                  {{ currentTime }}
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            dense
            class="mt-4"
          >
            <v-col
              cols="12"
              md="6"
            >
              <vuetify-money
                v-model="initialCash"
                class="elevated-input"
                outlined
                label="Valor inicial"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="selectedPrinters"
                :items="printers"
                item-text="location"
                item-value="id"
                return-object
                multiple
                chips
                label="Impressora de comandas (opcional)"
                outlined
                :loading="loadingPrinters"
                :disabled="loadingPrinters"
                :error-messages="printerError ? [printerError] : []"
                class="elevated-input"
                hide-details
              />
            </v-col>
          </v-row>

          <v-alert
            v-if="printerError"
            type="error"
            dense
            outlined
            class="mt-2"
          >
            {{ printerError }}
          </v-alert>
        </v-card-text>
        <v-divider class="mt-4"></v-divider>
        <v-card-actions>
          <v-row no-gutters>
            <v-col>
              <v-btn
                color="primary"
                x-large
                dark
                class=" float-right"
                @click="storeOpenCash()"
              >
                Abrir CAixa
              </v-btn>

              <v-btn
                color="secondary"
                text
                x-large
                class=" float-right mr-2 "
                @click="dialog=false"
              >
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {
  mdiWindowClose,
} from '@mdi/js'

import { mapActions, mapMutations } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    BarTitleDialog,
  },
  props: {
    value: { type: Boolean },
  },
  data: () => ({
    dialog: false,
    notBills: false,
    showModalBillToPay: false,
    initialCash: 0,
    printers: [],
    selectedPrinters: [],
    printerError: null,
    loadingPrinters: false,
    currentDate: '',
    currentTime: '',
    icons: {
      mdiWindowClose,
    },
  }),
  computed: {
    currentUserName() {
      const user = this.$store.getters['login/getUser']

      return user?.name || 'Usuário'
    },
  },
  methods: {
    ...mapActions('cash', ['openCash']),
    ...mapActions('printers', { listPrinters: 'list' }),
    ...mapMutations('cash', ['setCash']),

    async preparePrinters() {
      this.printerError = null
      try {
        const savedPrinters = JSON.parse(localStorage.getItem('printerSelection'))
        this.selectedPrinters = Array.isArray(savedPrinters)
          ? savedPrinters.filter(item => item && item.printer_key)
          : []
      } catch (error) {
        this.selectedPrinters = []
        localStorage.removeItem('printerSelection')
      }
      this.loadingPrinters = true
      try {
        const response = await this.listPrinters()
        this.printers = response.data || []
        const selectedKeys = this.selectedPrinters.map(item => item.printer_key)
        this.selectedPrinters = this.printers.filter(item => selectedKeys.includes(item.printer_key))
      } catch (error) {
        this.printerError = 'Não foi possível carregar as impressoras. O caixa ainda pode ser aberto.'
      } finally {
        this.loadingPrinters = false
      }
    },
    storeOpenCash() {
      this.printerError = null
      const validPrinters = this.selectedPrinters.filter(item => item && item.printer_key)
      if (validPrinters.length) {
        localStorage.setItem('printerSelection', JSON.stringify(validPrinters))
      } else {
        localStorage.removeItem('printerSelection')
      }

      this.openCash(this.initialCash)
        .then(response => {
          this.setCash(response.data)
          this.$router.push('cash')
        }).catch()
        .finally()
    },
    setNow() {
      const now = new Date()
      this.currentDate = now.toLocaleDateString('pt-BR')
      this.currentTime = now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },
  },
  watch: {
    value(val) {
      this.dialog = val
      if (val) {
        this.setNow()
        this.preparePrinters()
      }
    },
    dialog(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style scoped>
.elevated-input :deep(.v-input__slot) {
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  border-radius: 12px;
}

.elevated-input :deep(input),
.elevated-input :deep(.v-select__selections) {
  min-height: 56px;
  display: flex;
  align-items: center;
}

.v-card__text {
  padding-bottom: 16px !important;
}
</style>
